// Google maps api key
export const GOOGLE_MAPS_KEY = 'AIzaSyCeaIR_SLm3HPMPgcBctPNtCuRGuyV6-IU';

// Loader options
export const LOADER_OPTIONS = {
    backgroundColor: '#555357',
    canCancel: true, 
    color: '#345AAD',
    isFullPage: true,
    loader: 'bars'
}

// Regex
export const PHONE_REGEX = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;